import { Edit } from "react-admin";
import * as React from "react";
import { ContentCreateForm } from "./ContentCreate";

export const ContentEdit = () => (
  <Edit>
    <ContentCreateForm />
  </Edit>
);
